import type { ReactNode } from 'react'
import { NotificationsModal } from './NotificationsModal'
import { UpdatesProvider } from './UpdatesProvider'

/** Mount inside authenticated layout. Exposes updates via useUpdates() for TopBar. */
export function UpdatesHost({ children }: { children?: ReactNode }) {
  return (
    <UpdatesProvider>
      {children}
      <NotificationsModal />
    </UpdatesProvider>
  )
}

export { useUpdates } from './UpdatesProvider'
